import Vue from 'vue'
import Router from 'vue-router'
import store from './store.js'
import axios from 'axios'
import { userKey, urlApi, applyAuthToStore } from '@/config/global'

import Home from '../views/Home'
import Login from '../views/Login'
import Consulta from '../views/Consulta'
import Artefato from '../views/Artefato'
import Research from '../views/Research'
import ParecerParametrizado from '../views/ParecerParametrizado'
import AnalisadoresProcesso from '../views/AnalisadoresProcesso'
import GerenciarUsuarios from '../views/GerenciarUsuarios'
import Relatorios from '../views/Relatorios'
import TipoEnvolvidoAssinatura from '../views/TipoEnvolvidoAssinatura'
import RelatorioUso from '../views/RelatorioUso'
import Normativa from '../views/Normativa'
import ProcessoInteligente from '../views/ProcessoInteligente'
import DetalhesProcesso from '../views/DetalhesProcesso'
import SolicitacaoEnvio from '../views/SolicitacaoEnvio'
import SollAcademyVisuzalizador from '../views/SollAcademyVisuzalizador.vue'
import SollAcademyMinhasTrilhas from '../views/SollAcademyMinhasTrilhas.vue'
import SollAcademyTrilhas from '../views/SollAcademyTrilhas.vue'
import SollAcademy from '../views/SollAcademy.vue'
import ProcessoWorkflow from '../views/ProcessoWorkflow.vue'
import DetalhesWorkflow from '../views/DetalhesWorkflow.vue'
import ProcessoAprovacao from '../views/ProcessoAprovacao.vue'
import ProcessoRevisao from '../views/ProcessoRevisao.vue'
import ProcessoArtefatoInteracao from '../views/ProcessoArtefatoInteracao.vue'
import ProcessoRevisado from '../views/ProcessoRevisado.vue'
import ProcessoAssinatura from '../views/ProcessoAssinatura.vue'
import ModeloPersonalizado from '../views/ModeloPersonalizado.vue'
import ArtefatosGeraisStatus from '../views/ArtefatosGeraisStatus.vue'
import Orientacao from '../views/Orientacao.vue'
import Detalheorientacao from '../views/DetalhesOrientacao.vue'
import CatalogoItens from '../views/CatalogoItens.vue'
import GerenciarUnidadeSetor from '../views/GerenciarUnidadeSetor.vue'
import DashboardProcesso from '../views/DashboardProcesso.vue'
import RegistroNecessidade from '../views/RegistroNecessidade.vue'
// import RequisicaoCompra from '../views/RequisicaoCompra/RequisicaoCompra.vue'
// import ModeloFormulario from '../views/RequisicaoCompra/ModeloFormulario.vue'


// Ferramentas
import Fornecedores from '../views/Ferramentas/Fornecedores/Fornecedores.vue'
import DetalheFornecedor from '../views/Ferramentas/Fornecedores/DetalheFornecedor.vue'
import Editais from '../views/Ferramentas/Editais/Editais.vue'
import DetalheEdital from '../views/Ferramentas/Editais/DetalheEdital.vue'
import BancoPenalidades from '../views/Ferramentas/BancoPenalidades/BancoPenalidades.vue'
import DetalhePenalidade from '../views/Ferramentas/BancoPenalidades/DetalhePenalidade.vue'
import Periodicos from '../views/Ferramentas/Periodicos/Periodicos.vue'
import ListaPeriodicos from '../views/Ferramentas/Periodicos/ListaPeriodicos.vue'
import PesquisaPeriodicos from '../views/Ferramentas/Periodicos/PesquisaPeriodicos.vue'
import Revista from '../views/Ferramentas/Periodicos/Revista.vue'
import LeitorPdf from '../views/Ferramentas/Periodicos/LeitorPdf.vue'
import LeiComentada from '../views/Ferramentas/LeiComentada/LeiComentada.vue'
import Modelos from '../views/Ferramentas/Modelos/Modelos.vue'
import Pesquisa from '../views/Ferramentas/Pesquisa/Pesquisa.vue'
import LeitorPdfFerramenta from '../views/Ferramentas/Pesquisa/LeitorPdfFerramenta.vue'

Vue.use(Router)

const router = new Router({
    mode: 'history',
    routes: [

        {
            path: '/',
            component: Login,
            name: 'Login',
            meta: { authenticated: false },
        },

        {
            path: '/Home',
            component: Home,
            name: 'Home',
            meta: { authenticated: true },
        },
        {
            path: '/Consulta',
            component: Consulta,
            name: 'Consulta',
            meta: { authenticated: true, flProduto: true, cdProduto: 'SC', cdTipoLog: 'SC_ACS_CONS' },
        },
        {
            path: '/Artefato',
            component: Artefato,
            name: 'Artefato',
            meta: { authenticated: true, flProduto: true, cdProduto: 'SC', cdTipoLog: 'SC_ACS_ART' },
        },
        {
            path: '/AnalisadoresProcesso',
            component: AnalisadoresProcesso,
            name: 'AnalisadoresProcesso',
meta: { authenticated: true, flProduto: true, cdProduto: 'AP', cdTipoLog: 'PI_ACS_ANAL' },
        },
        {
            path: '/Research',
            component: Research,
            name: 'Research',
            meta: { authenticated: true, flProduto: true, cdProduto: 'SC', cdTipoLog: 'SC_ACS_RES' },
        },
        {
            path: '/ParecerParametrizado',
            component: ParecerParametrizado,
            name: 'ParecerParametrizado',
            meta: { authenticated: true, flProduto: true, cdProduto: 'SC', cdTipoLog: 'SC_ACS_PARPA' },
        },
        {
            path: '/GerenciarUsuarios',
            component: GerenciarUsuarios,
            name: 'GerenciarUsuarios',
            meta: { authenticated: true, cdTipoLog: 'ADM_ACS_USR' },
        },
        {
            path: '/Relatorios',
            component: Relatorios,
            name: 'Relatorios',
            meta: { authenticated: true },
        },
        {
            path: '/GerenciarUnidadeSetor',
            component: GerenciarUnidadeSetor,
            name: 'GerenciarUnidadeSetor',
            meta: { authenticated: true, cdTipoLog: 'ADM_ACS_UNID_SET' },
        },
        {
            path: '/TipoEnvolvidoAssinatura',
            component: TipoEnvolvidoAssinatura,
            name: 'TipoEnvolvidoAssinatura',
            meta: { authenticated: true, cdTipoLog: 'PI_ACS_TP_ENVOLV' },
        },

        {
            path: '/RelatorioUso',
            component: RelatorioUso,
            name: 'RelatorioUso',
            meta: { authenticated: true, cdTipoLog: 'ADM_ACS_REL_USO' },
        },

        {
            path: '/Normativa',
            component: Normativa,
            name: 'Normativa',
            meta: { authenticated: true, cdTipoLog: 'ADM_ACS_NRM' },
        },
        {
            path: '/RegistroNecessidade',
            component: RegistroNecessidade,
            name: 'RegistroNecessidade',
            meta: { authenticated: true, flProduto: true, cdProduto: 'PI', cdTipoLog: 'PI_ACS_RN' },
        },
        {
            path: '/ProcessosInteligentes',
            component: ProcessoInteligente,
            name: 'ProcessoInteligente',
            meta: { authenticated: true, flProduto: true, cdProduto: 'PI', cdTipoLog: 'PI_ACS_PROC' },
        },
        {
            path: '/Processo/:id',
            component: DetalhesProcesso,
            name: 'DetalhesProcesso',
            props: true,
            meta: { authenticated: true, flProduto: true, cdProduto: 'PI', cdTipoLog: 'PI_ACS_PROC_DET' },
        },
        {
            path: '/StatusArtefatos',
            component: ArtefatosGeraisStatus,
            name: 'ArtefatosGeraisStatus',
            props: true,
            meta: { authenticated: true, flProduto: true, cdProduto: 'PI', cdTipoLog: 'PI_ACS_ST_ART' },
        },
        {
            path: '/AprovacaoProcesso/:id',
            component: ProcessoAprovacao,
            name: 'ProcessoAprovacao',
            props: true,
            meta: { authenticated: true, flProduto: true, cdProduto: 'PI', cdTipoLog: 'PI_ACS_APROV' },
        },
        {
            path: '/RevisaoProcesso/:id',
            component: ProcessoRevisao,
            name: 'ProcessoRevisao',
            props: true,
            meta: { authenticated: true, flProduto: true, cdProduto: 'PI', cdTipoLog: 'PI_ACS_REV' },
        },
        {
            path: '/InteracaoArtefato/:id',
            component: ProcessoArtefatoInteracao,
            name: 'ProcessoArtefatoInteracao',
            props: true,
            meta: { authenticated: true, flProduto: true, cdProduto: 'PI', cdTipoLog: 'PI_ACS_INT_ART' },
        },
        {
            path: '/ControleArtefato/:id',
            component: ProcessoRevisado,
            name: 'ProcessoRevisado',
            props: true,
            meta: { authenticated: true, flProduto: true, cdProduto: 'PI', cdTipoLog: 'PI_ACS_CTRL_ART' },
        },
        {
            path: '/AssinaturaProcesso/:id',
            component: ProcessoAssinatura,
            name: 'ProcessoAssinatura',
            props: true,
            meta: { authenticated: true, flProduto: true, cdProduto: 'PI', cdTipoLog: 'PI_ACS_ASSIN' },
        },
        {
            path: '/ProcessosWorkflow',
            component: ProcessoWorkflow,
            name: 'ProcessoWorkflow',
            props: true,
            meta: { authenticated: true, flProduto: true, cdProduto: 'PI', cdTipoLog: 'PI_ACS_WKF' },
        },
        {
            path: '/Workflow/:id',
            component: DetalhesWorkflow,
            name: 'DetalhesWorkflow',
            props: true,
            meta: { authenticated: true, flProduto: true, cdProduto: 'PI', cdTipoLog: 'PI_ACS_WKF' },
        },
        {
            path: '/ModeloPersonalizado',
            component: ModeloPersonalizado,
            name: 'ModeloPersonalizado',
            meta: { authenticated: true, flProduto: true, cdProduto: 'PI', cdTipoLog: 'PI_ACS_MOD_PERS' },
        },
        {
            path: '/CatalogoItens',
            component: CatalogoItens,
            name: 'CatalogoItens',
            meta: { authenticated: true, flProduto: true, cdProduto: 'PI', cdTipoLog: 'PI_ACS_CAT' },
        },
        {
            path: '/DashboardProcesso',
            component: DashboardProcesso,
            name: 'DashboardProcesso',
            props: true,
            meta: { authenticated: true, flProduto: true, cdProduto: 'PI', cdTipoLog: 'PI_ACS_DASH' },
        },
        {
            path: '/SolicitacaoEnvio',
            component: SolicitacaoEnvio,
            name: 'SolicitacaoEnvio',
            props: true,
            meta: { authenticated: false },
        },
        {
            path: '/SollAcademyAula',
            component: SollAcademyVisuzalizador,
            name: 'SollAcademyAula',
            props: true,
            meta: { authenticated: true, flProduto: true, cdProduto: 'SA', cdTipoLog: 'SA_ACS_AULA' },
        },
        {
            path: '/SollAcademy',
            component: SollAcademy,
            name: 'SollAcademy',
            props: true,
            meta: { authenticated: true, flProduto: true, cdProduto: 'SA', cdTipoLog: 'SA_ACS_ACAD' },
        },
        {
            path: '/SollAcademyMinhasTrilhas',
            component: SollAcademyMinhasTrilhas,
            name: 'SollAcademyMinhasTrilhas',
            props: true,
            meta: { authenticated: true, flProduto: true, cdProduto: 'SA', cdTipoLog: 'SA_ACS_MIN_TRILHA' },
        },
        {
            path: '/SollAcademyTrilhas',
            component: SollAcademyTrilhas,
            name: 'SollAcademyTrilhas',
            props: true,
            meta: { authenticated: true, flProduto: true, cdProduto: 'SA', cdTipoLog: 'SA_ACS_TRILHA' },
        },
        {
            path: '/Orientacoes',
            component: Orientacao,
            name: 'Orientacoes',
            props: true,
            meta: { authenticated: true, flProduto: true, cdProduto: 'SO', cdTipoLog: 'SO_ACS_ORI' },
        },
        {
            path: '/Orientacao/:id',
            component: Detalheorientacao,
            name: 'Detalheorientacao',
            props: true,
            meta: { authenticated: true, flProduto: true, cdProduto: 'SO', cdTipoLog: 'SO_ACS_ORI_DET' },
        },
        // {
        //     path: '/RequisicaoCompra',
        //     component: RequisicaoCompra,
        //     name: 'RequisicaoCompra',
        //     props: true,
        //     meta: { authenticated: true, flProduto: true, cdProduto: 'PI', cdTipoLog: 'PI_ACS_REQCOM' },
        // },
        // {
        //     path: '/ModeloFormulario',
        //     component: ModeloFormulario,
        //     name: 'ModeloFormulario',
        //     props: true,
        //     meta: { authenticated: true, flProduto: true, cdProduto: 'PI', cdTipoLog: 'PI_ACS_MODFOR' },
        // },


        // Ferramentas
        {
            path: '/Fornecedores',
            component: Fornecedores,
            name: 'Fornecedores',
            meta: { authenticated: true, keepAlive: true,  cdTipoLog: 'SC_ACS_FORN' },
        },
        {
            path: '/DetalheFornecedor',
            component: DetalheFornecedor,
            name: 'DetalheFornecedor',
            meta: { authenticated: true, cdTipoLog: 'SC_ACS_FORN_DET' },
            props: true,
        },
        {
            path: '/Editais',
            component: Editais,
            name: 'Editais',
            meta: { authenticated: true, keepAlive: true, cdTipoLog: 'SC_ACS_EDITAIS' },
        },
        {
            path: '/DetalheEdital',
            component: DetalheEdital,
            name: 'DetalheEdital',
            meta: { authenticated: true,  cdTipoLog: 'SC_ACS_EDITAIS_DET' },
            props: true,
        },
        {
            path: '/BancoPenalidades',
            component: BancoPenalidades,
            name: 'BancoPenalidades',
            meta: { authenticated: true, keepAlive: true, cdTipoLog: 'SC_ACS_BANPEN' },
        },
        {
            path: '/DetalhePenalidade',
            component: DetalhePenalidade,
            name: 'DetalhePenalidade',
            meta: { authenticated: true, cdTipoLog: 'SC_ACS_BANPEN_DET' },
            props: true,
        },
        {
            path: '/Periodicos',
            component: Periodicos,
            name: 'Periodicos',
            meta: { authenticated: true, cdTipoLog: 'SC_ACS_PERIO' },
        },
        {
            path: '/ListaPeriodicos/:tipo/',
            component: ListaPeriodicos,
            name: 'ListaPeriodicos',
            props: true,
            meta: { authenticated: true, cdTipoLog: 'SC_ACS_PERIO' },
        },
        {
            path: '/PesquisaPeriodicos/:termo',
            component: PesquisaPeriodicos,
            name: 'PesquisaPeriodicos',
            props: true,
            meta: { authenticated: true, cdTipoLog: 'SC_ACS_PES_PERIO' },
        },
        {
            path: '/Revista/:idPeriodico/',
            component: Revista,
            name: 'Revista',
            props: true,
            meta: { authenticated: true, cdTipoLog: 'SC_ACS_REV_PERIO' },
        },
        {
            path: '/LeitorPdf/:idPeriodico',
            component: LeitorPdf,
            name: 'LeitorPdf',
            props: true,
            meta: { authenticated: true, cdTipoLog: 'SC_ACS_PDF_PERIO' },
        },
        {
            path: '/LeiComentada',
            component: LeiComentada,
            name: 'LeiComentada',
            meta: { authenticated: true, keepAlive: true, cdTipoLog: 'SC_ACS_LEICOM' },
        },
        {
            path: '/Modelos',
            component: Modelos,
            name: 'Modelos',
            meta: { authenticated: true, keepAlive: true, cdTipoLog: 'SC_ACS_MOD' },
        },
        {
            path: '/Pesquisa',
            component: Pesquisa,
            name: 'Pesquisa',
            meta: { authenticated: true, cdTipoLog: 'SC_ACS_PESQ' },
        },
        {
            path: '/LeitorPdfArquivo',
            component: LeitorPdfFerramenta,
            name: 'LeitorPdfFerramenta',
            meta: { authenticated: true },
        },

        // redirect
        {
            path: '/redirect',
            redirect: '/'
        },
        // 404
        {
            path: '*',
            redirect: '/'
        }
    ],
    scrollBehavior() {
        return { x: 0, y: 0 }
    }
})

const cdTipoLogModulo = {
    SC: 'SC_ACS_MODULO',
    PI: 'PI_ACS_MODULO',
    SA: 'SA_ACS_MODULO',
    SO: 'SO_ACS_MODULO',
}

// último produto acessado, para que o log de módulo só saia na entrada do produto
let cdProdutoCorrente = null

const registraLog = (cdTipoLog) => {
    if (!cdTipoLog) return
    axios.post(`${urlApi}/Log/Registrar`, { cdTipoLog }).catch(() => { })
}

router.beforeEach((to, from, next) => {
    // removendo css do login
    if (to.matched.some(record => record.meta.authenticated)) {
        // rota logado
        let user = store.getters.getUser
        var flProduto = to.matched.some(record => record.meta.flProduto);

        if (!user) {
            // deslogado
            const json = localStorage.getItem(userKey)
            const userData = JSON.parse(json)

            const req = async () => {
                try {
                    const res = await axios.post(`${urlApi}/Auth/refresh`, userData)
                    if (res.data) {
                        if (res.data.token.authenticated) {
                            applyAuthToStore(store, res.data)
                            
                            // verifica produto
                            if (flProduto) {
                                const verificaProduto = async () => {
                                    try {
                                        const resProduto = await axios.get(`${urlApi}/Produto/VerificaAcessoProduto`, { params: { cdProduto: to.meta.cdProduto } })
                                        if (resProduto.data) {
                                            if (resProduto.data.data == 'Sim') {
                                                // LOG ACESSOPRODUTO
                                                axios.post(`${urlApi}/Log/AcessoProduto`, { 'cdProduto': to.meta.cdProduto });
                                                next();
                                            } else {
                                                next({ name: 'Home' });
                                            }
                                        } else {
                                            next({ name: 'Home' });
                                        }
                                    } catch (err) {
                                        next({ name: 'Home' });
                                    }
                                };

                                verificaProduto();
                            } else {
                                if (to.matched.some(record => record.meta.cdProduto)) {
                                    // LOG ACESSOPRODUTO
                                    axios.post(`${urlApi}/Log/AcessoProduto`, { 'cdProduto': to.meta.cdProduto });
                                }
                                next()
                            }
                        } else {
                            store.commit('setUser', null);
                            next({ name: 'Login' });
                        }
                    } else {
                        next({ name: 'Login' });
                    }
                } catch (err) {
                    next({ name: 'Login' });
                }
            };

            req();

        } else {
            // logado
            // verifica produto
            if (flProduto) {
                const verificaProduto = async () => {
                    try {
                        const resProduto = await axios.get(`${urlApi}/Produto/VerificaAcessoProduto`, { params: { cdProduto: to.meta.cdProduto } })
                        if (resProduto.data) {
                            if (resProduto.data.data == 'Sim') {
                                // LOG ACESSOPRODUTO
                                axios.post(`${urlApi}/Log/AcessoProduto`, { 'cdProduto': to.meta.cdProduto });
                                next();
                            } else {
                                next({ name: 'Home' });
                            }
                        } else {
                            next({ name: 'Home' });
                        }
                    } catch (err) {
                        next({ name: 'Home' });
                    }
                };

                verificaProduto();
            } else {
                if (user.authenticated) {
                    if (to.matched.some(record => record.meta.cdProduto)) {
                        // LOG ACESSOPRODUTO
                        axios.post(`${urlApi}/Log/AcessoProduto`, { 'cdProduto': to.meta.cdProduto });
                    }

                    next()
                } else {
                    next(false)
                }
            }
        }

    } else {
        // rota deslogado
        if (to.meta.styles) {
            // Carregue dinamicamente os estilos
            next()
        } else {
            next()
        }
    }
})

router.afterEach((to) => {
    if (!to.meta || !to.meta.authenticated) {
        cdProdutoCorrente = null
        return
    }

    const cdProduto = to.meta.cdProduto

    if (cdProduto !== cdProdutoCorrente) {
        cdProdutoCorrente = cdProduto
        registraLog(cdTipoLogModulo[cdProduto])
    }

    registraLog(to.meta.cdTipoLog)
})

export default router